import { ErrorOutline } from "@mui/icons-material";
import { Box, FormHelperText } from "@mui/material";
import React from "react";

function WalkInHelperText({ helperText, errors }) {
  return (
    <FormHelperText component={"span"}>
      <span
        style={{
          color: "#FF3932",
          fontFamily: "Poppins-Regular",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          visibility: errors ? "visible" : "hidden",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ErrorOutline />
        </Box>
        {helperText}
      </span>
    </FormHelperText>
  );
}

export default WalkInHelperText;
